export default function Logo() {
  return (
    <img
      src="/logo-black.svg"
      alt="Alkina Realty"
      className="h-10 md:h-16 w-auto"
    />
  );
}


